var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-center dimensions-100"},[_c('p',{staticClass:"error-page-403"},[_vm._v("403")]),_c('p',{staticClass:"dark-purple-text font-weight-bold display-1 text-align-center"},[_vm._v(" Access Denied ")]),_c('h2',{staticClass:"text-align-center dark-purple-text"},[_vm._v(" You don't have permission to access this resource ")])])
}]

export { render, staticRenderFns }